import React from "react";
import styles from "./PageHeader.module.css";

/**
 * Unified Standard Page Header Component for Admin Management Sections
 * 
 * @param {Object} props
 * @param {React.ComponentType|React.ReactNode} props.icon - Feather or FontAwesome icon
 * @param {string} props.title - Main page title
 * @param {string} props.subtitle - Page description / subtitle
 * @param {string|number} [props.badge] - Optional badge count or status pill text
 * @param {React.ReactNode} [props.actions] - Right-side header action buttons
 * @param {React.ReactNode} [props.breadcrumb] - Optional back navigation breadcrumb
 */
function PageHeader({ icon: Icon, title, subtitle, badge, actions, breadcrumb }) {
  const renderIcon = () => {
    if (!Icon) return null;
    if (React.isValidElement(Icon)) return Icon;
    const IconComponent = Icon;
    return <IconComponent size={24} />;
  };

  return (
    <div>
      {breadcrumb && (
        <div className="mb-2">
          {breadcrumb}
        </div>
      )}
      <div className={styles.headerContainer}>
        <div className={styles.headerLeft}>
          {Icon && (
            <div className={styles.iconWrapper}>
              {renderIcon()}
            </div>
          )}
          <div className={styles.titleArea}>
            <div className={styles.titleRow}>
              <h3 className={styles.titleText}>{title}</h3>
              {badge !== undefined && badge !== null && (
                <span className={styles.badgePill}>{badge}</span>
              )}
            </div>
            {subtitle && <p className={styles.subtitleText}>{subtitle}</p>}
          </div>
        </div>

        {actions && <div className={styles.headerRight}>{actions}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
